import { useFormContext } from 'react-hook-form'
import { type SkillDomain } from '../../../types/domain/skill-domain'

type CheckboxComboProps = {
  name: string
  options?: SkillDomain[]
  checkedOptions: SkillDomain[]
  translationLabel: 'portugueseName' | 'englishName' | 'spanishName'
}

export const CheckboxCombo = ({
  name,
  options,
  checkedOptions,
  translationLabel,
}: CheckboxComboProps) => {
  const { register } = useFormContext()

  const isDefaultChecked = (optionId: number) => {
    return checkedOptions.some((checkedOption) => checkedOption.id === optionId)
  }

  return (
    <>
      {options?.map((option: any, index: number) => (
        <div key={option.id} className="mb-2">
          <label key={option.id} className="flex gap-2 mb">
            <input
              type="checkbox"
              className="inline-flex items-center justify-center flex-shrink-0 w-6 h-6 border rounded-md appearance-none border-grey-500 checked:border-primary-light checked:bg-primary-light before:self-end checked:before:content-checkIcon"
              id={option.id}
              value={option.id}
              defaultChecked={isDefaultChecked(option.id)}
              {...register(`${name}.${index}.id`)}
            />
            <span>{option[translationLabel]}</span>
          </label>
        </div>
      ))}
    </>
  )
}
